export const resolvePublicUrl = (value?: string | null) => {
  if (!value) return undefined

  const normalized = value.trim().replace(/\\/g, '/')
  if (!normalized) return undefined

  if (/^(https?:|data:|blob:)/i.test(normalized)) {
    return normalized
  }

  return normalized.startsWith('/') ? normalized : `/${normalized}`
}
